import React from 'react'
import PropTypes from 'prop-types'
import { ProjectFilter } from './projectFilter'
import { ValidationFilter } from './validationFilter'
import { SourceFilter } from './sourceFilter'
import { ProductFilter } from './productFilter'

export function MeetingsFilters({
  projects,
  projectIndex,
  setProjectIndex,
  validation,
  setValidation,
  projectFilterEnabled,
  source,
  setSource,
  product,
  setProduct,
  products,
}) {
  return (
    <div className="flex items-center">
      {Array.isArray(products) && products.length > 0 && (
        <ProductFilter product={product} setProduct={setProduct} products={products} />
      )}
      <SourceFilter source={source} setSource={setSource} />
      {projectFilterEnabled ? (
        <ProjectFilter projects={projects} projectIndex={projectIndex} setProjectIndex={setProjectIndex} />
      ) : null}
      <ValidationFilter validation={validation} setValidation={setValidation} />
    </div>
  )
}

MeetingsFilters.propTypes = {
  projects: PropTypes.array,
  projectIndex: PropTypes.number,
  setProjectIndex: PropTypes.func,
  validation: PropTypes.string,
  setValidation: PropTypes.func,
  projectFilterEnabled: PropTypes.bool,
  source: PropTypes.string,
  setSource: PropTypes.func,
  product: PropTypes.string,
  setProduct: PropTypes.func,
  products: PropTypes.array,
}
